import React from "react";

const LoadingScreen = () => {
  return (
    <div className="flex items-center justify-center mt-[10vh] lg:mt-20 flex-col space-y-8 p-10">
      {/* Attractive Concentric Spinning Rings */}
      <div className="relative w-24 h-24">
        <div className="absolute inset-0 border-4 border-blue-200 border-t-blue-500 rounded-full animate-spin"></div>
        <div className="absolute inset-3 border-4 border-indigo-300 border-t-indigo-500 rounded-full animate-spin" style={{ animationDuration: '1.5s' }}></div>
        <div className="absolute inset-6 border-4 border-purple-300 border-t-purple-500 rounded-full animate-spin" style={{ animationDuration: '2s' }}></div>
      </div>

      {/* Engaging Loading Text */}
      <div className="text-center">
        <p className="text-xl font-semibold text-blue-600 animate-pulse">
          Preparing your experience...
        </p>
        <p className="text-sm text-gray-500 mt-2">
          This may take a moment
        </p>
      </div>
    </div>
  );
};

export default LoadingScreen;
